import { html } from 'lit';

export const workTaskStyles = html`<style>
  .zw-tasks {
    max-width: 1480px;
    margin: 0 auto;
    padding: 36px 30px 64px;
    color: #202630;
  }
  .zw-tasks *,
  .zw-tasks *::before,
  .zw-tasks *::after {
    box-sizing: border-box;
  }
  .zw-tasks :is(h1, h2, h3, p, dl, dd) {
    margin: 0;
  }
  .zw-tasks :is(button, input, textarea, select) {
    font-family: inherit;
  }
  .zw-tasks :is(button, a, input, textarea, select, summary):focus-visible {
    outline: 2px solid #d6001c;
    outline-offset: 3px;
  }
  .zw-task-page-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 27px;
  }
  .zw-task-eyebrow {
    color: #c8001c;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }
  .zw-tasks h1 {
    margin-top: 9px;
    font-size: clamp(28px, 3vw, 36px);
    line-height: 1.2;
    letter-spacing: -0.035em;
    font-weight: 750;
  }
  .zw-task-intro {
    max-width: 670px;
    margin-top: 12px !important;
    color: #667085;
    font-size: 13px;
    line-height: 1.8;
  }
  .zw-task-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    min-height: 39px;
    padding: 9px 14px;
    background: #fff;
    border: 1px solid #dce2eb;
    border-radius: 8px;
    color: #475467;
    font-size: 12px;
    font-weight: 650;
    line-height: 1.4;
    cursor: pointer;
    white-space: nowrap;
  }
  .zw-task-button:hover:not(:disabled) {
    background: #f6f8fb;
    border-color: #aebbd0;
  }
  .zw-task-button:disabled {
    opacity: 0.48;
    cursor: not-allowed;
  }
  .zw-task-primary {
    background: #d6001c;
    border-color: #d6001c;
    color: #fff;
  }
  .zw-task-primary:hover:not(:disabled) {
    background: #b70018;
    border-color: #b70018;
  }
  .zw-task-approve {
    background: #166b4c;
    border-color: #166b4c;
    color: #fff;
  }
  .zw-task-approve:hover:not(:disabled) {
    background: #10543b;
    border-color: #10543b;
  }
  .zw-task-summary {
    display: grid;
    grid-template-columns: minmax(0, 0.85fr) minmax(0, 0.85fr) minmax(0, 1.3fr);
    gap: 15px;
    margin-bottom: 25px;
  }
  .zw-task-summary > div {
    padding: 21px 24px;
    border: 1px solid #e2e7ee;
    border-radius: 12px;
    background: #fff;
  }
  .zw-task-summary span {
    display: block;
    color: #536278;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-summary strong {
    display: block;
    margin-top: 8px;
    color: #243751;
    font-size: 31px;
    font-weight: 750;
    letter-spacing: -0.03em;
    line-height: 1.2;
  }
  .zw-task-summary strong em {
    font-size: 18px;
    font-weight: 500;
    font-style: normal;
  }
  .zw-task-summary small {
    display: block;
    margin-top: 7px;
    color: #8490a2;
    font-size: 11px;
  }
  .zw-task-summary .zw-task-summary-wait {
    background: #fffcf6;
    border-color: #eee3ce;
  }
  .zw-task-summary .zw-task-summary-wait strong {
    color: #936515;
  }
  .zw-task-summary .zw-task-summary-hours {
    background: #f6fbf8;
    border-color: #d9e9e0;
    display: block;
  }
  .zw-task-hours-totals {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
    margin-top: 16px;
  }
  .zw-task-hours-metric {
    min-width: 0;
  }
  .zw-task-hours-metric[data-summary='billable'] {
    border-left: 1px solid #d9e9e0;
    padding-left: 18px;
  }
  .zw-task-summary .zw-task-hours-metric strong {
    margin-top: 6px;
    font-size: 28px;
    overflow-wrap: anywhere;
  }
  .zw-task-summary .zw-task-hours-metric[data-summary='billable'] strong {
    color: #267653;
  }
  .zw-task-summary .zw-task-hours-pending {
    color: #805c16;
  }
  .zw-task-summary .zw-task-hours-note {
    margin-top: 14px;
    line-height: 1.5;
  }
  .zw-task-views {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 5px;
    border: 1px solid #dce3ed;
    border-radius: 12px;
    background: #eef2f7;
    width: fit-content;
    max-width: 100%;
  }
  .zw-task-views button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 11px 18px;
    border: 1px solid transparent;
    border-radius: 8px;
    background: transparent;
    color: #56657a;
    font-size: 14px;
    font-weight: 650;
    cursor: pointer;
  }
  .zw-task-views button[aria-pressed='true'] {
    background: #fff;
    border-color: #dce3ed;
    color: #243751;
    box-shadow: 0 2px 5px #2233490a;
  }
  .zw-task-views button:disabled {
    cursor: default;
    opacity: 0.6;
  }
  .zw-task-views button span {
    padding: 2px 7px;
    background: #e7edf5;
    border-radius: 6px;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
  .zw-task-view-help {
    margin: 12px 0 22px !important;
    font-size: 12px;
    line-height: 1.7;
    color: #667085;
  }
  .zw-task-archived-pill {
    border: 1px solid #cfd6df;
    border-radius: 6px;
    padding: 5px 9px;
    background: #f0f2f5;
    color: #596477;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-dates {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 18px;
    line-height: 1.5;
  }
  .zw-task-archive-confirm {
    background: #f7f9fc;
  }
  .zw-task-alert,
  .zw-task-notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    margin-bottom: 18px;
    padding: 13px 17px;
    border: 1px solid #efc8d0;
    border-radius: 10px;
    color: #a92840;
    background: #fff6f8;
    font-size: 12px;
    line-height: 1.7;
  }
  .zw-task-notice {
    justify-content: flex-start;
    background: #f1faf4;
    border-color: #cce6d5;
    color: #216643;
  }
  .zw-task-toolbar {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    padding: 16px;
    border: 1px solid #e1e6ee;
    border-radius: 11px;
    background: #fff;
  }
  .zw-task-search {
    display: flex;
    align-items: center;
    gap: 9px;
    flex: 1 1 270px;
    min-width: 200px;
    padding: 0 11px;
    border: 1px solid #d9e0e9;
    border-radius: 8px;
    color: #8895a7;
  }
  .zw-task-toolbar input,
  .zw-task-toolbar select {
    background: #fff;
    font-size: 12px;
    color: #475467;
  }
  .zw-task-search input {
    min-width: 0;
    width: 100%;
    height: 38px;
    border: 0;
    padding: 8px 0;
  }
  .zw-task-search input:focus-visible {
    outline-offset: 0;
  }
  .zw-task-toolbar select {
    height: 40px;
    border: 1px solid #d9e0e9;
    border-radius: 8px;
    padding: 8px 24px 8px 10px;
    max-width: 100%;
  }
  .zw-task-list-caption {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
    padding: 15px 3px;
    font-size: 11px;
    color: #7d889b;
  }
  .zw-task-list {
    display: grid;
    gap: 17px;
  }
  .zw-task-card {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 230px;
    border: 1px solid #e0e6ee;
    border-radius: 14px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 3px 10px #26395603;
  }
  .zw-task-card-main {
    padding: 25px 27px 22px;
    min-width: 0;
  }
  .zw-task-card-tags {
    display: flex;
    gap: 9px;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 13px;
  }
  .zw-task-status-pill,
  .zw-task-approval-pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 650;
    line-height: 1.5;
  }
  .zw-task-status-pill[data-status='raised'] {
    background: #fff5df;
    color: #936413;
  }
  .zw-task-status-pill[data-status='acknowledged'] {
    background: #eef5ff;
    color: #2867ad;
  }
  .zw-task-status-pill[data-status='test-staging'] {
    background: #f5efff;
    color: #8056aa;
  }
  .zw-task-status-pill[data-status='ready-for-production'] {
    background: #edf9f1;
    color: #28744d;
  }
  .zw-task-approval-pill {
    background: #f6f7f9;
    border: 1px solid #e3e7ee;
    color: #7b8493;
  }
  .zw-task-approval-pill[data-approved='true'] {
    background: #f0f9f4;
    border-color: #d5eadd;
    color: #28744d;
  }
  .zw-task-revision {
    font-size: 10px;
    color: #98a2b3;
  }
  .zw-task-card h2 {
    font-size: 18px;
    font-weight: 700;
    line-height: 1.45;
    letter-spacing: -0.018em;
    color: #27364c;
    overflow-wrap: anywhere;
  }
  .zw-task-description {
    margin-top: 10px !important;
    font-size: 12px;
    line-height: 1.9;
    color: #647087;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  .zw-task-delivery {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-top: 17px;
    color: #6c7a8f;
    font-size: 11px;
    line-height: 1.7;
  }
  .zw-task-delivery svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
  .zw-task-delivery strong {
    color: #485a72;
    font-weight: 650;
    margin-right: 5px;
  }
  .zw-task-linked-feedback {
    margin-top: 15px;
    font-size: 11px;
  }
  .zw-task-linked-feedback summary {
    cursor: pointer;
    color: #596e89;
    font-weight: 650;
  }
  .zw-task-linked-feedback summary span {
    margin-left: 6px;
  }
  .zw-task-linked-feedback > div {
    display: grid;
    gap: 8px;
    margin-top: 10px;
  }
  .zw-task-independent {
    display: block;
    margin-top: 14px;
    font-size: 10px;
    color: #97a1af;
  }
  .zw-task-source {
    display: flex;
    gap: 11px;
    align-items: flex-start;
    padding: 12px;
    border: 1px solid #e0e7f0;
    border-radius: 8px;
    background: #f8faff;
    color: #51657f;
    text-decoration: none;
  }
  .zw-task-source:hover {
    border-color: #bccce1;
    background: #f4f7fc;
  }
  .zw-task-source-icon {
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #edf1f8;
    border-radius: 6px;
  }
  .zw-task-source > span:last-child {
    min-width: 0;
  }
  .zw-task-source strong {
    display: block;
    font-size: 11px;
    font-weight: 650;
  }
  .zw-task-source-preview {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: anywhere;
    margin-top: 4px;
    font-size: 11px;
    line-height: 1.7;
  }
  .zw-task-source small {
    display: block;
    margin-top: 5px;
    font-size: 9px;
    color: #8c99ad;
    overflow-wrap: anywhere;
  }
  .zw-task-card-estimate {
    background: #fafbfe;
    margin: 20px 20px 20px 0;
    padding: 19px;
    border: 1px solid #edf0f6;
    border-radius: 10px;
    align-self: start;
  }
  .zw-task-hours-title {
    font-size: 10px;
    color: #7c89a0;
    font-weight: 650;
  }
  .zw-task-total {
    color: #263c59;
    font-size: 34px;
    font-weight: 750;
    letter-spacing: -0.035em;
    margin: 7px 0 13px;
    line-height: 1.2;
  }
  .zw-task-total > span {
    font-size: 18px;
    font-weight: 500;
    color: #8493a8;
  }
  .zw-task-card-estimate dl {
    border-top: 1px solid #e4e9f1;
    padding-top: 11px;
    display: grid;
    gap: 9px;
  }
  .zw-task-card-estimate dl > div {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    font-size: 11px;
  }
  .zw-task-card-estimate dt {
    color: #7c899c;
  }
  .zw-task-card-estimate dd {
    color: #52647c;
    font-weight: 650;
  }
  .zw-task-card-footer {
    grid-column: 1/-1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 17px 25px;
    border-top: 1px solid #edf0f5;
  }
  .zw-task-approval-meta {
    display: flex;
    gap: 10px;
    align-items: center;
    min-width: 0;
  }
  .zw-task-approval-meta strong {
    display: block;
    color: #66758a;
    font-size: 11px;
    font-weight: 650;
  }
  .zw-task-approval-meta small {
    display: block;
    color: #96a0af;
    font-size: 10px;
    margin-top: 4px;
    line-height: 1.5;
  }
  .zw-task-approved-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: #29744e;
    background: #eef8f1;
    flex-shrink: 0;
  }
  .zw-task-card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    justify-content: flex-end;
  }
  .zw-task-card-actions .zw-task-button {
    min-height: 35px;
    padding: 8px 11px;
    font-size: 11px;
  }
  .zw-task-status-select {
    max-width: 190px;
    min-height: 35px;
    padding: 6px 24px 6px 9px;
    font-size: 11px;
    color: #667085;
    background: #f9fafb;
    border: 1px solid #dde3ec;
    border-radius: 7px;
    cursor: pointer;
  }
  .zw-task-status-select:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .zw-task-updated {
    grid-column: 1/-1;
    padding: 0 25px 13px;
    color: #a0a9b7;
    font-size: 9px;
  }
  .zw-task-confirm {
    grid-column: 1/-1;
    margin: 0 24px 17px;
    padding: 17px;
    border: 1px solid #cfe3d8;
    background: #f4faf6;
    border-radius: 9px;
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .zw-task-confirm h3 {
    color: #326b4d;
    font-size: 13px;
  }
  .zw-task-confirm p {
    font-size: 12px;
    line-height: 1.8;
    color: #567462;
    margin-top: 7px;
  }
  .zw-task-approver-field {
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-width: 260px;
    margin-top: 13px;
    color: #426f54;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-approver-field select {
    width: 100%;
    padding: 9px 12px;
    border: 1px solid #c9ddd1;
    border-radius: 7px;
    background: #fff;
    color: #3c5f48;
    font-size: 13px;
    min-height: 39px;
  }
  .zw-task-confirm-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    flex-shrink: 0;
  }
  .zw-task-editor,
  .zw-task-link-panel {
    margin: 0 0 24px;
    border: 1px solid #d9e1eb;
    border-radius: 13px;
    background: #fff;
    overflow: hidden;
    scroll-margin-top: 20px;
  }
  .zw-task-editor-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    padding: 22px 25px;
    border-bottom: 1px solid #edf0f5;
  }
  .zw-task-editor-head h2 {
    font-size: 20px;
    color: #2e3d54;
    font-weight: 700;
    margin-top: 6px;
  }
  .zw-task-draft-label {
    color: #91a0b4;
    background: #f3f6fa;
    font-size: 10px;
    font-weight: 650;
    padding: 6px 9px;
    border-radius: 6px;
  }
  .zw-task-form-layout {
    display: grid;
    grid-template-columns: minmax(0, 1.6fr) minmax(260px, 1fr);
    gap: 27px;
    padding: 24px 25px;
  }
  .zw-task-form-main {
    display: grid;
    gap: 20px;
    align-content: start;
  }
  .zw-task-editor label,
  .zw-task-link-controls label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #516077;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-editor input,
  .zw-task-editor textarea,
  .zw-task-link-controls select {
    width: 100%;
    min-width: 0;
    padding: 10px 12px;
    border: 1px solid #d7dfea;
    border-radius: 8px;
    color: #3e4f68;
    background: #fff;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
  }
  .zw-task-editor :is(input, textarea)::placeholder {
    color: #a0abbc;
    font-size: 12px;
  }
  .zw-task-editor textarea {
    resize: vertical;
    min-height: 120px;
  }
  .zw-task-editor :is(input, textarea):disabled {
    opacity: 0.65;
    background: #f8f9fc;
  }
  .zw-task-form-sources h3 {
    color: #7a889d;
    font-size: 11px;
    margin-bottom: 10px;
  }
  .zw-task-form-sources h3 span {
    margin-left: 5px;
    padding: 2px 6px;
    background: #f0f3f8;
    border-radius: 4px;
  }
  .zw-task-form-sources .zw-task-source + .zw-task-source {
    margin-top: 8px;
  }
  .zw-task-help {
    color: #8895a8;
    font-size: 11px;
    line-height: 1.75;
  }
  .zw-task-estimate-form {
    padding: 20px;
    border: 1px solid #e6ebf3;
    border-radius: 10px;
    background: #fafbfe;
    align-self: start;
  }
  .zw-task-estimate-form h3 {
    color: #4c607b;
    font-size: 13px;
    margin-bottom: 6px;
  }
  .zw-task-estimate-form > .zw-task-help:last-child {
    margin-top: 10px;
  }
  .zw-task-hour-inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 13px;
    margin-top: 20px;
  }
  .zw-task-input-unit {
    display: flex;
    align-items: center;
    border: 1px solid #d7dfea;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
  }
  .zw-task-input-unit input {
    border: 0;
    border-radius: 0;
  }
  .zw-task-input-unit > span {
    padding-right: 12px;
    color: #8896aa;
    font-weight: 500;
  }
  .zw-task-total-preview {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    margin: 16px 0 21px;
    padding: 15px 0;
    border-top: 1px solid #e4e9f1;
    border-bottom: 1px solid #e4e9f1;
  }
  .zw-task-total-preview span {
    color: #78879c;
    font-size: 11px;
  }
  .zw-task-total-preview strong {
    color: #314c6f;
    font-size: 22px;
    white-space: nowrap;
  }
  .zw-task-approval-change {
    margin: 0 25px 20px !important;
    padding: 12px 15px;
    border: 1px solid #efdfbd;
    border-radius: 8px;
    background: #fffbf2;
    color: #957030;
    font-size: 11px;
    line-height: 1.8;
  }
  .zw-task-editor-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 18px 25px;
    border-top: 1px solid #edf0f5;
  }
  .zw-task-editor-footer > span {
    color: #94a0b2;
    font-size: 11px;
    line-height: 1.7;
  }
  .zw-task-editor-footer > div {
    display: flex;
    gap: 8px;
  }
  .zw-task-link-panel > .zw-task-source {
    margin: 18px 25px;
  }
  .zw-task-link-controls {
    display: flex;
    align-items: flex-end;
    gap: 14px;
    padding: 0 25px 16px;
  }
  .zw-task-link-controls label {
    flex: 1;
    min-width: 0;
  }
  .zw-task-link-panel > .zw-task-help {
    padding: 0 25px 20px;
  }
  .zw-task-empty {
    padding: 55px 25px;
    text-align: center;
    border: 1px dashed #d6dfe9;
    border-radius: 13px;
    background: #fbfcfe;
    color: #8793a5;
  }
  .zw-task-empty-symbol {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background: #eff3f8;
    color: #889ab1;
    border-radius: 12px;
    font-size: 23px;
    margin-bottom: 15px;
  }
  .zw-task-empty h2 {
    color: #586a84;
    font-size: 17px;
    font-weight: 650;
  }
  .zw-task-empty p {
    font-size: 12px;
    line-height: 1.8;
    margin-top: 8px;
  }
  .zw-task-empty .zw-task-button {
    margin-top: 20px;
  }
  .zw-task-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
  .zw-task-card {
    --task-accent: #be841f;
    border-left: 4px solid var(--task-accent);
    box-shadow: 0 5px 22px #26395608;
  }
  .zw-task-card[data-priority='high'] {
    --task-accent: #ce4f55;
  }
  .zw-task-card[data-priority='low'] {
    --task-accent: #4e8998;
  }
  .zw-task-card[data-pinned='true'] {
    outline: 1px solid #b7cbe5;
    box-shadow: 0 6px 24px #36639914;
  }
  .zw-task-card-topline {
    grid-column: 1/-1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 25px;
    background: #f8fafe;
    border-bottom: 1px solid #e9eef5;
    gap: 12px;
  }
  .zw-task-priority {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    color: #765314;
    font-size: 11px;
    font-weight: 700;
  }
  .zw-task-priority[data-priority='high'] {
    color: #a32e3c;
  }
  .zw-task-priority[data-priority='low'] {
    color: #386674;
  }
  .zw-task-pin {
    display: inline-flex;
    gap: 6px;
    align-items: center;
    color: #52657e;
    background: #fff;
    border: 1px solid #dce4ef;
    border-radius: 7px;
    padding: 6px 10px;
    font: inherit;
    font-size: 11px;
    cursor: pointer;
  }
  .zw-task-pin[aria-pressed='true'] {
    background: #e8f0fd;
    color: #245992;
    border-color: #b5ccea;
  }
  .zw-task-pin:disabled,
  .zw-task-add-feedback:disabled {
    opacity: 0.5;
    cursor: default;
  }
  .zw-task-pin:focus-visible,
  .zw-task-add-feedback:focus-visible,
  .zw-task-source-link:focus-visible {
    outline: 2px solid #3277b9;
    outline-offset: 3px;
  }
  .zw-task-card h2 {
    font-size: 20px;
  }
  .zw-task-description {
    font-size: 13px;
    color: #52617a;
  }
  .zw-task-source-preview {
    display: block;
    white-space: pre-wrap;
    max-height: 18rem;
    overflow: auto;
    -webkit-line-clamp: unset;
    color: #405674;
  }
  .zw-task-source-link {
    display: inline-block;
    margin-top: 8px;
    color: #285f9c;
    font-size: 11px;
    overflow-wrap: anywhere;
  }
  .zw-task-add-feedback {
    display: block;
    margin-top: 12px;
    padding: 6px 0;
    border: 0;
    background: transparent;
    color: #28649e;
    font: inherit;
    font-size: 11px;
    font-weight: 650;
    cursor: pointer;
  }
  .zw-task-attach {
    margin-top: 10px;
    padding: 14px;
    background: #f6f9fe;
    border: 1px solid #dce5f2;
    border-radius: 8px;
  }
  .zw-task-attach label {
    display: grid;
    gap: 7px;
    font-size: 12px;
  }
  .zw-task-attach input,
  .zw-task-estimate-form select {
    width: 100%;
    min-width: 0;
    border: 1px solid #d8e1ed;
    background: #fff;
    color: #344b68;
    border-radius: 7px;
    padding: 10px;
    font: inherit;
  }
  .zw-task-attach .zw-task-button {
    margin-top: 10px;
  }
  .zw-task-range {
    min-width: 0;
    border: 0;
    margin: 0;
    padding: 0;
  }
  .zw-task-range legend {
    font-size: 12px;
    font-weight: 700;
    color: #3a506c;
    margin-bottom: 7px;
  }
  .zw-task-range > div {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 10px;
  }
  .zw-task-range label {
    font-size: 10px;
    color: #62718a;
  }
  .zw-task-pin-option {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    gap: 8px;
  }
  .zw-task-pin-option input {
    width: 16px !important;
    height: 16px;
    accent-color: #2f6fae;
  }
  .zw-task-open-note {
    font-size: 12px;
    padding: 12px;
    border-radius: 8px;
    background: #fff4dd;
    color: #795914;
    line-height: 1.7;
  }
  .zw-task-total {
    font-size: 30px;
    overflow-wrap: anywhere;
  }
  .zw-task-total[data-open='true'] {
    color: #957020;
  }
  .zw-task-toolbar {
    flex-wrap: wrap;
  }
  .zw-task-head-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: flex-end;
  }
  .zw-task-export-state {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin: 14px 0;
    padding: 14px 18px;
    border: 1px solid #d7e3f4;
    border-radius: 10px;
    background: #f3f7fe;
    color: #365776;
    font-size: 12px;
  }
  .zw-task-export-state > div {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
  .zw-task-estimate-form > label,
  .zw-task-range {
    margin-top: 16px;
  }
  .zw-task-status-pill[data-status='approved'] {
    background: #e8f6f0;
    color: #226448;
  }
  .zw-task-status-pill[data-status='implemented'] {
    background: #eaf1fb;
    color: #355e91;
  }
  .zw-task-description-details {
    margin-top: 12px;
    color: #60748d;
    font-size: 11px;
  }
  .zw-task-description-details summary {
    cursor: pointer;
    font-weight: 650;
    line-height: 1.7;
  }
  .zw-task-description-preview {
    display: block;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.8;
    color: #697b93;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    margin-top: 5px;
  }
  .zw-task-description-details[open] .zw-task-description-preview {
    display: none;
  }
  .zw-task-kind-pill {
    display: inline-flex;
    border: 1px solid #d9e5f7;
    background: #f1f6ff;
    color: #365f91;
    font-size: 10px;
    font-weight: 650;
    border-radius: 6px;
    padding: 4px 8px;
  }
  .zw-task-kind-pill[data-kind='bug'] {
    color: #8a4650;
    background: #fff2f3;
    border-color: #efd8dd;
  }
  .zw-task-kind-pill[data-kind='unclassified'] {
    color: #7a6440;
    background: #fff9ed;
    border-color: #eadfcb;
  }
  .zw-task-title-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px;
  }
  .zw-task-number {
    display: inline-flex;
    flex-shrink: 0;
    color: #576c88;
    background: #edf2f9;
    font-size: 11px;
    line-height: 1.5;
    padding: 4px 7px;
    border-radius: 5px;
    font-variant-numeric: tabular-nums;
    font-weight: 750;
    letter-spacing: 0.015em;
    white-space: nowrap;
  }
  .zw-task-final-hours {
    margin-top: 17px;
    padding-top: 14px;
    border-top: 1px solid #dfe7f1;
    display: grid;
    gap: 5px;
  }
  .zw-task-final-hours > span {
    color: #617690;
    font-size: 10px;
    font-weight: 650;
  }
  .zw-task-final-hours strong {
    font-size: 19px;
    color: #2b5a70;
  }
  .zw-task-final-hours small {
    font-size: 10px;
    color: #718199;
  }
  .zw-task-form-layout {
    display: block;
  }
  .zw-task-form-main {
    gap: 16px;
  }
  .zw-task-editor textarea {
    min-height: 100px;
  }
  .zw-task-section-heading {
    display: flex;
    align-items: center;
    gap: 9px;
    min-height: 25px;
    margin-bottom: 2px;
  }
  .zw-task-section-heading > span:first-child {
    display: grid;
    place-items: center;
    width: 25px;
    height: 25px;
    border-radius: 7px;
    background: #eaf0f8;
    color: #687e9d;
    font-size: 10px;
    font-weight: 750;
  }
  .zw-task-section-heading h3 {
    font-size: 13px;
    color: #344c6a;
    margin: 0;
  }
  .zw-task-section-heading small {
    margin-left: auto;
    color: #8795aa;
    font-size: 10px;
  }
  .zw-task-section-heading .zw-task-number {
    margin-left: auto;
  }
  .zw-task-form-sources {
    font-size: 11px;
    color: #526987;
    background: #f8faff;
    border: 1px solid #e4eaf4;
    border-radius: 8px;
    padding: 12px 14px;
  }
  .zw-task-form-sources summary {
    cursor: pointer;
    font-weight: 650;
  }
  .zw-task-form-sources summary span {
    margin-left: 7px;
    background: #e9f0fa;
    padding: 2px 6px;
    border-radius: 4px;
  }
  .zw-task-form-sources > div {
    display: grid;
    gap: 8px;
    padding-top: 12px;
  }
  .zw-task-planning-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
    margin-top: 23px;
    align-items: start;
  }
  .zw-task-planning-grid[data-billing='true'] {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .zw-task-form-group {
    display: grid;
    align-content: start;
    gap: 13px;
    padding: 19px;
    border: 1px solid #e1e8f2;
    border-radius: 11px;
    background: #f9fbfe;
    margin: 0;
  }
  .zw-task-form-group label {
    margin-top: 0;
  }
  .zw-task-form-group select {
    width: 100%;
    min-width: 0;
    border: 1px solid #d7dfea;
    background: #fff;
    color: #3e4f68;
    border-radius: 8px;
    padding: 10px 12px;
    font: inherit;
    min-height: 41px;
  }
  .zw-task-form-group .zw-task-range {
    margin-top: 0;
  }
  .zw-task-form-group .zw-task-total-preview {
    margin: 0;
    padding-bottom: 0;
    border-bottom: 0;
  }
  .zw-task-billing-form {
    background: #f4f9f8;
    border-color: #d9e8e1;
  }
  .zw-task-billing-form .zw-task-section-heading > span:first-child {
    background: #e4f0e9;
    color: #497c64;
  }
  .zw-task-kind-billing-warning {
    padding: 12px;
    border: 1px solid #ead8b2;
    background: #fff8e9;
    border-radius: 8px;
    color: #876326;
    font-size: 11px;
    line-height: 1.75;
  }
  .zw-task-kind-billing-warning strong {
    display: block;
    margin-bottom: 3px;
    font-weight: 750;
  }
  .zw-task-billing-rule {
    padding: 12px;
    background: #e9f3ee;
    color: #547460;
    font-size: 11px;
    line-height: 1.7;
    border-radius: 8px;
  }
  .zw-task-legacy-delivery {
    color: #8894a4;
    font-size: 10px;
    line-height: 1.8;
  }
  .zw-task-legacy-delivery summary {
    cursor: pointer;
  }
  .zw-task-legacy-delivery p {
    margin-top: 6px;
  }
  .zw-task-billing-panel {
    margin: 0 0 24px;
    border: 1px solid #d6e2ee;
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
  }
  .zw-task-billing-panel > summary {
    display: flex;
    align-items: center;
    gap: 13px;
    cursor: pointer;
    list-style: none;
    padding: 19px 22px;
    background: linear-gradient(110deg, #f6f9ff, #f5faf7);
  }
  .zw-task-billing-panel > summary::-webkit-details-marker {
    display: none;
  }
  .zw-task-billing-chevron {
    width: 8px;
    height: 8px;
    flex-shrink: 0;
    border-right: 2px solid #6d819c;
    border-bottom: 2px solid #6d819c;
    transform: rotate(45deg);
    margin: 0 2px 4px 9px;
  }
  .zw-task-billing-panel[open] .zw-task-billing-chevron {
    transform: rotate(225deg);
    margin-bottom: 0;
  }
  .zw-task-billing-icon {
    display: grid;
    place-items: center;
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: #e6edf8;
    color: #4e6991;
    font-size: 20px;
    flex-shrink: 0;
  }
  .zw-task-billing-panel summary strong {
    display: block;
    color: #314963;
    font-size: 14px;
  }
  .zw-task-billing-panel summary small {
    display: block;
    color: #7b8a9e;
    font-size: 11px;
    margin-top: 4px;
  }
  .zw-task-billing-summary {
    margin-left: auto;
    font-size: 12px;
    font-weight: 700;
    color: #39735c;
    white-space: nowrap;
  }
  .zw-task-billing-content {
    padding: 22px;
    border-top: 1px solid #e3eaf3;
  }
  .zw-task-billing-controls {
    display: flex;
    align-items: flex-end;
    gap: 13px;
    flex-wrap: wrap;
    margin-bottom: 13px;
  }
  .zw-task-billing-controls label {
    display: grid;
    gap: 7px;
    color: #4e627c;
    font-size: 11px;
    font-weight: 650;
  }
  .zw-task-billing-controls input {
    font: inherit;
    color: #314d6e;
    border: 1px solid #d4dfed;
    border-radius: 8px;
    background: #fff;
    padding: 10px 12px;
    min-height: 39px;
  }
  .zw-task-billing-controls .zw-task-button {
    margin-left: auto;
  }
  .zw-task-billing-table-wrap {
    overflow: auto;
    margin-top: 18px;
    border: 1px solid #e1e8f1;
    border-radius: 9px;
  }
  .zw-task-billing-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    font-size: 12px;
  }
  .zw-task-billing-table th {
    padding: 12px 15px;
    background: #f5f8fc;
    color: #6f8199;
    font-size: 10px;
    font-weight: 700;
  }
  .zw-task-billing-table td {
    padding: 13px 15px;
    border-top: 1px solid #e8edf4;
    color: #4b617d;
    line-height: 1.6;
  }
  .zw-task-billing-table td:first-child {
    min-width: 240px;
  }
  .zw-task-billing-table td strong {
    display: block;
    margin-top: 5px;
    color: #3c506b;
    font-size: 12px;
  }
  .zw-task-billing-table :is(td, th):last-child {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
  .zw-task-billing-table tfoot :is(td, th) {
    background: #edf6f1;
    color: #32674f;
    font-size: 12px;
    font-weight: 750;
    border-top: 1px solid #d6e6dc;
    padding: 14px 15px;
  }
  .zw-task-billing-exclusions {
    display: flex;
    gap: 7px;
    flex-wrap: wrap;
    margin-top: 16px;
  }
  .zw-task-billing-exclusions span {
    font-size: 10px;
    color: #7b6c52;
    background: #fcf8f0;
    border: 1px solid #eee4d4;
    border-radius: 5px;
    padding: 5px 8px;
  }
  .zw-task-billing-footnote {
    margin-top: 17px !important;
    color: #8895a7;
    font-size: 10px;
    line-height: 1.7;
  }
  .zw-task-billing-empty {
    margin: 18px 0 !important;
    padding: 23px;
    border: 1px dashed #d9e2ee;
    border-radius: 9px;
    text-align: center;
    color: #7d8da4;
    font-size: 12px;
  }
  .zw-task-billing-error {
    margin-top: 12px !important;
    color: #a83845;
    background: #fff5f5;
    padding: 11px;
    border-radius: 7px;
    font-size: 12px;
  }
  @media (max-width: 1100px) {
    .zw-task-planning-grid[data-billing='true'] {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .zw-task-billing-form {
      grid-column: 1/-1;
    }
  }
  @media (max-width: 1000px) {
    .zw-task-summary {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .zw-task-summary-hours {
      grid-column: 1 / -1;
    }
    .zw-task-card {
      grid-template-columns: minmax(0, 1fr) 195px;
    }
    .zw-task-card-estimate {
      padding: 15px;
      margin-right: 16px;
    }
    .zw-task-card-footer {
      align-items: flex-start;
      flex-direction: column;
    }
    .zw-task-card-actions {
      justify-content: flex-start;
    }
    .zw-task-form-layout {
      grid-template-columns: minmax(0, 1fr);
    }
    .zw-task-confirm {
      flex-direction: column;
      align-items: flex-start;
    }
    .zw-task-summary > div {
      padding: 18px;
    }
  }
  @media (max-width: 640px) {
    .zw-task-views {
      width: 100%;
      gap: 3px;
    }
    .zw-task-views button {
      flex: 1;
      padding: 10px 8px;
      gap: 6px;
      font-size: 12px;
    }
    .zw-tasks {
      padding: 25px 16px 42px;
    }
    .zw-task-page-head {
      align-items: flex-start;
      flex-direction: column;
      gap: 18px;
    }
    .zw-task-summary {
      grid-template-columns: minmax(0, 1fr);
      gap: 9px;
    }
    .zw-task-summary > div {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 5px 15px;
      padding: 15px 17px;
    }
    .zw-task-summary strong {
      grid-column: 2;
      grid-row: 1 / 3;
      margin: 0;
      font-size: 27px;
      align-self: center;
    }
    .zw-task-summary small {
      margin: 0;
    }
    .zw-task-card {
      grid-template-columns: minmax(0, 1fr);
    }
    .zw-task-card-topline {
      padding: 11px 18px;
    }
    .zw-task-card-estimate > .zw-task-help {
      grid-column: 2;
      grid-row: 1/3;
      margin: 0;
    }
    .zw-task-card-main {
      padding: 20px 18px;
    }
    .zw-task-card-estimate {
      margin: 0 18px 18px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 7px 16px;
    }
    .zw-task-hours-title {
      align-self: end;
    }
    .zw-task-total {
      grid-column: 1;
      margin: 0;
      font-size: 28px;
    }
    .zw-task-card-estimate dl {
      grid-column: 2;
      grid-row: 1/3;
      padding: 4px 0 4px 15px;
      border-top: 0;
      border-left: 1px solid #e4e9f1;
      align-content: center;
    }
    .zw-task-card-footer {
      padding: 16px 18px;
    }
    .zw-task-updated {
      padding-left: 18px;
    }
    .zw-task-toolbar {
      gap: 9px;
      padding: 12px;
    }
    .zw-task-search {
      flex-basis: 100%;
    }
    .zw-task-toolbar > label:not(.zw-task-search) {
      flex: 1 1 130px;
    }
    .zw-task-toolbar select {
      width: 100%;
    }
    .zw-task-editor-head {
      padding: 20px 17px;
    }
    .zw-task-draft-label {
      display: none;
    }
    .zw-task-form-layout {
      padding: 20px 17px;
      gap: 20px;
    }
    .zw-task-estimate-form {
      padding: 16px;
    }
    .zw-task-editor-footer {
      padding: 17px;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }
    .zw-task-editor-footer > div {
      justify-content: flex-end;
    }
    .zw-task-link-controls {
      padding: 0 17px 16px;
      flex-direction: column;
      align-items: stretch;
    }
    .zw-task-link-panel > .zw-task-source {
      margin: 17px;
    }
    .zw-task-link-panel > .zw-task-help {
      padding: 0 17px 17px;
    }
    .zw-task-confirm {
      margin: 0 17px 17px;
      padding: 14px;
    }
    .zw-task-approval-change {
      margin-left: 17px !important;
      margin-right: 17px !important;
    }
    .zw-task-alert {
      align-items: flex-start;
      flex-direction: column;
    }
  }
  @media (max-width: 640px) {
    .zw-task-planning-grid,
    .zw-task-planning-grid[data-billing='true'] {
      grid-template-columns: minmax(0, 1fr);
    }
    .zw-task-billing-panel > summary {
      padding: 16px;
      gap: 9px;
      flex-wrap: wrap;
    }
    .zw-task-billing-summary {
      order: 3;
      margin-left: 45px;
      flex-basis: 100%;
    }
    .zw-task-billing-chevron {
      margin-left: auto;
    }
    .zw-task-billing-content {
      padding: 16px;
    }
    .zw-task-billing-controls > label {
      flex: 1;
      min-width: 125px;
    }
    .zw-task-billing-controls input {
      width: 100%;
      min-width: 0;
    }
    .zw-task-billing-controls .zw-task-button {
      width: 100%;
      margin-left: 0;
      white-space: normal;
    }
    .zw-task-final-hours {
      grid-column: 1/-1;
    }
    .zw-task-title-row {
      display: block;
    }
    .zw-task-title-row h2 {
      margin-top: 9px;
    }
    .zw-task-card-actions {
      width: 100%;
    }
    .zw-task-card-actions .zw-task-button {
      white-space: normal;
    }
  }
  .zw-task-language-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 19px;
    flex-wrap: wrap;
  }
  .zw-task-language-bar > small {
    color: #7a899e;
    font-size: 11px;
    line-height: 1.6;
  }
  .zw-task-language-toggle {
    display: inline-flex;
    gap: 3px;
    padding: 4px;
    border: 1px solid #d9e2ef;
    background: #eef3f9;
    border-radius: 10px;
  }
  .zw-task-language-toggle button {
    border: 0;
    background: transparent;
    border-radius: 7px;
    padding: 8px 14px;
    font: inherit;
    color: #6a7d95;
    cursor: pointer;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-language-toggle button[aria-pressed='true'] {
    background: #fff;
    box-shadow: 0 2px 5px #20385212;
    color: #263d5c;
  }
  .zw-task-schedule-heading {
    padding-top: 17px;
    margin-top: 4px;
    border-top: 1px solid #dfe6f0;
  }
  .zw-task-schedule-heading h3 {
    font-size: 12px;
    color: #3f5876;
    margin-bottom: 6px;
  }
  .zw-task-duration {
    display: flex;
    align-items: baseline;
    gap: 10px;
    background: #f4f7fb;
    border-radius: 7px;
    padding: 10px 12px;
    margin-top: 9px;
    font-size: 11px;
    line-height: 1.6;
  }
  .zw-task-metric-label {
    color: #71829a;
    flex-shrink: 0;
  }
  .zw-task-duration strong {
    color: #445f7d;
    font-weight: 600;
    overflow-wrap: anywhere;
  }
  .zw-task-delivery {
    margin-top: 18px;
    padding: 10px 12px;
    border: 1px solid #e1e9f3;
    border-radius: 7px;
    background: #fbfcff;
  }
  .zw-task-translation-ready {
    color: #708ba3;
    font-size: 10px;
    margin-top: 8px !important;
  }
  .zw-task-translation-state {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 9px 11px;
    margin-top: 11px;
    background: #fff8e9;
    color: #8a6b30;
    border: 1px solid #ecdfbf;
    border-radius: 8px;
    font-size: 11px;
    line-height: 1.6;
  }
  .zw-task-translation-state .zw-task-button {
    min-height: 30px;
    padding: 5px 9px;
    font-size: 10px;
    white-space: normal;
  }
  .zw-task-field-translation {
    padding: 11px 13px;
    border: 1px solid #d9e5f4;
    border-left: 3px solid #b4cce9;
    border-radius: 7px;
    background: #f3f7fd;
    margin-top: -6px;
  }
  .zw-task-field-translation small {
    display: block;
    font-size: 10px;
    color: #7291b3;
    font-weight: 650;
    margin-bottom: 6px;
  }
  .zw-task-field-translation p {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    color: #48617e;
    font-size: 12px;
    line-height: 1.8;
  }
  .zw-task-translation-note {
    color: #9a835e;
    font-size: 10px;
    line-height: 1.6;
  }
  .zw-task-editor-language-note {
    color: #687f9c;
    background: #eef4fc;
    padding: 11px 13px;
    border-radius: 8px;
    font-size: 11px;
    line-height: 1.7;
    margin-bottom: 15px !important;
  }
  .zw-task-form-layout > .zw-task-translation-state {
    margin-bottom: 16px;
  }
  .zw-task-editor-footer {
    background: #fbfcfe;
    box-shadow: 0 -2px 10px #263f5e04;
  }
  .zw-task-editor-footer .zw-task-primary {
    min-width: 135px;
  }
  .zw-task-form-group {
    box-shadow: 0 3px 12px #1f3f6c03;
  }
  .zw-task-form-sources {
    margin-top: 2px;
  }
  @media (max-width: 640px) {
    .zw-task-language-bar {
      align-items: flex-start;
      flex-direction: column;
      gap: 8px;
    }
    .zw-task-duration {
      flex-direction: column;
      gap: 3px;
    }
    .zw-task-translation-state {
      align-items: flex-start;
      flex-direction: column;
    }
    .zw-task-field-translation {
      padding: 10px;
    }
    .zw-task-head-actions {
      justify-content: flex-start;
    }
    .zw-task-head-actions .zw-task-button {
      white-space: normal;
    }
    .zw-task-editor-footer > div {
      flex-wrap: wrap;
    }
  }
  /* Task cards: one reading flow, with schedule and effort in one planning row. */
  .zw-task-card {
    grid-template-columns: minmax(0, 1fr);
    border-radius: 15px;
  }
  .zw-task-card-topline {
    padding: 14px 26px;
  }
  .zw-task-card .zw-task-priority,
  .zw-task-card .zw-task-pin {
    font-size: 13px;
  }
  .zw-task-card .zw-task-pin {
    padding: 8px 12px;
  }
  .zw-task-card-main {
    padding: 25px 26px 24px;
  }
  .zw-task-card-tags {
    gap: 8px;
    margin-bottom: 15px;
  }
  .zw-task-card :is(.zw-task-status-pill, .zw-task-kind-pill, .zw-task-approval-pill) {
    font-size: 12px;
    padding: 5px 9px;
  }
  .zw-task-card .zw-task-title-row {
    align-items: baseline;
    gap: 12px;
  }
  .zw-task-card .zw-task-number {
    font-size: 13px;
    padding: 5px 9px;
  }
  .zw-task-card h2 {
    font-size: 24px;
    line-height: 1.4;
    letter-spacing: -0.02em;
  }
  .zw-task-card .zw-task-description {
    font-size: 15px;
    line-height: 1.8;
    margin-top: 14px !important;
    color: #455a74;
  }
  .zw-task-card .zw-task-description-details {
    margin-top: 15px;
  }
  .zw-task-card .zw-task-description-details summary {
    font-size: 14px;
  }
  .zw-task-card .zw-task-description-preview {
    font-size: 15px;
    line-height: 1.8;
    margin-top: 7px;
  }
  .zw-task-plan-metrics {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.3fr) minmax(0, 1fr);
    gap: 14px;
    margin-top: 24px;
    padding: 18px;
    border: 1px solid #dce5f0;
    border-radius: 12px;
    background: #f5f8fc;
    align-items: start;
  }
  .zw-task-plan-metrics :is(.zw-task-delivery, .zw-task-duration, .zw-task-card-estimate) {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    background: transparent;
    min-width: 0;
  }
  .zw-task-plan-metrics .zw-task-delivery {
    padding-right: 13px;
  }
  .zw-task-plan-metrics .zw-task-duration {
    padding: 0 15px;
    border-left: 1px solid #dce5f0;
    border-right: 1px solid #dce5f0;
  }
  .zw-task-plan-metrics .zw-task-metric-label {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #617590;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.55;
  }
  .zw-task-plan-metrics .zw-task-delivery svg {
    margin: 0;
  }
  .zw-task-plan-metrics .zw-task-release-value {
    font-size: 25px;
    line-height: 1.35;
    color: #254b78;
    font-weight: 750;
    letter-spacing: -0.02em;
    margin: 0;
    overflow-wrap: anywhere;
  }
  .zw-task-plan-metrics .zw-task-release-value[data-unset='true'] {
    font-size: 21px;
    color: #6e8098;
  }
  .zw-task-plan-metrics .zw-task-duration > strong {
    font-size: 20px;
    line-height: 1.5;
    font-weight: 650;
    color: #334e70;
    overflow-wrap: anywhere;
  }
  .zw-task-plan-metrics .zw-task-card-estimate {
    padding-left: 3px;
  }
  .zw-task-plan-metrics .zw-task-hours-title {
    color: #617590;
    font-size: 13px;
    line-height: 1.55;
  }
  .zw-task-plan-metrics .zw-task-total {
    font-size: 28px;
    line-height: 1.25;
    margin: 0;
  }
  .zw-task-plan-metrics .zw-task-card-estimate dl {
    gap: 7px;
    padding-top: 10px;
    margin-top: 1px;
    border-top: 1px solid #dce5f0;
    border-left: 0;
  }
  .zw-task-plan-metrics .zw-task-card-estimate dl > div {
    font-size: 13px;
  }
  .zw-task-plan-metrics .zw-task-card-estimate > .zw-task-help {
    font-size: 13px;
    line-height: 1.7;
  }
  .zw-task-plan-metrics .zw-task-final-hours {
    margin-top: 1px;
    padding-top: 11px;
    gap: 4px;
  }
  .zw-task-plan-metrics .zw-task-final-hours > span {
    font-size: 12px;
  }
  .zw-task-plan-metrics .zw-task-final-hours strong {
    font-size: 21px;
  }
  .zw-task-plan-metrics .zw-task-final-hours small {
    font-size: 12px;
    line-height: 1.6;
  }
  .zw-task-card .zw-task-linked-feedback {
    margin-top: 22px;
    font-size: 14px;
  }
  .zw-task-card .zw-task-independent {
    margin-top: 19px;
    font-size: 12px;
  }
  .zw-task-card .zw-task-add-feedback {
    font-size: 13px;
    padding: 8px 0;
    margin-top: 8px;
  }
  .zw-task-card .zw-task-source strong {
    font-size: 13px;
  }
  .zw-task-card .zw-task-source-preview {
    font-size: 14px;
    line-height: 1.8;
  }
  .zw-task-card .zw-task-source small {
    font-size: 11px;
  }
  .zw-task-card .zw-task-source-link {
    font-size: 13px;
  }
  .zw-task-card-footer {
    padding: 20px 26px;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 18px 22px;
    background: #fcfdff;
  }
  .zw-task-card .zw-task-approval-meta strong {
    font-size: 13px;
    line-height: 1.5;
  }
  .zw-task-card .zw-task-approval-meta small {
    font-size: 12px;
    line-height: 1.6;
  }
  .zw-task-card-actions {
    gap: 9px;
  }
  .zw-task-card-actions .zw-task-button,
  .zw-task-card-actions .zw-task-status-select {
    font-size: 13px;
    min-height: 40px;
    padding: 9px 12px;
  }
  .zw-task-card-actions .zw-task-status-select {
    max-width: 220px;
  }
  .zw-task-card .zw-task-updated {
    font-size: 11px;
    padding: 0 26px 16px;
    background: #fcfdff;
  }
  .zw-task-card .zw-task-translation-ready {
    font-size: 11px;
    margin-top: 10px !important;
  }
  .zw-task-card .zw-task-translation-state {
    font-size: 13px;
  }
  @media (max-width: 800px) {
    .zw-task-plan-metrics {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }
    .zw-task-plan-metrics .zw-task-duration {
      border-right: 0;
      padding-right: 0;
    }
    .zw-task-plan-metrics .zw-task-card-estimate {
      grid-column: 1/-1;
      padding: 15px 0 0;
      border-top: 1px solid #dce5f0;
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      gap: 9px 20px;
    }
    .zw-task-plan-metrics .zw-task-hours-title {
      grid-column: 1;
    }
    .zw-task-plan-metrics .zw-task-total {
      grid-column: 1;
      grid-row: 2;
    }
    .zw-task-plan-metrics .zw-task-card-estimate dl {
      grid-column: 2;
      grid-row: 1/3;
      border-top: 0;
      padding: 0;
      margin: 0;
      align-content: center;
    }
    .zw-task-plan-metrics .zw-task-card-estimate > .zw-task-help {
      grid-column: 2;
      grid-row: 1/3;
    }
    .zw-task-plan-metrics .zw-task-final-hours {
      grid-column: 1/-1;
    }
  }
  @media (max-width: 640px) {
    .zw-task-card-main {
      padding: 22px 18px;
    }
    .zw-task-card-topline {
      padding: 12px 18px;
    }
    .zw-task-card h2 {
      font-size: 22px;
    }
    .zw-task-card .zw-task-title-row h2 {
      margin-top: 9px;
    }
    .zw-task-plan-metrics {
      grid-template-columns: minmax(0, 1fr);
      padding: 16px;
      gap: 17px;
      margin-top: 21px;
    }
    .zw-task-plan-metrics .zw-task-delivery {
      padding: 0;
    }
    .zw-task-plan-metrics .zw-task-duration {
      border-left: 0;
      border-top: 1px solid #dce5f0;
      padding: 15px 0 0;
    }
    .zw-task-plan-metrics .zw-task-release-value {
      font-size: 25px;
    }
    .zw-task-plan-metrics .zw-task-card-estimate {
      display: flex;
      gap: 10px;
    }
    .zw-task-plan-metrics .zw-task-card-estimate dl {
      border-top: 1px solid #dce5f0;
      padding-top: 10px;
    }
    .zw-task-card-footer {
      padding: 19px 18px;
    }
    .zw-task-card .zw-task-updated {
      padding: 0 18px 16px;
    }
    .zw-task-card-actions {
      justify-content: flex-start;
    }
    .zw-task-card-actions .zw-task-button {
      white-space: normal;
    }
  }

  .zw-task-board-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin: 24px 0 16px;
  }
  .zw-task-board-controls p,
  .zw-task-filter-scope {
    font-size: 13px;
    color: #667085;
    line-height: 1.6;
  }
  .zw-task-filter-scope {
    margin-top: 12px !important;
  }
  .zw-task-toolbar {
    flex-wrap: wrap;
  }
  .zw-task-board {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    align-items: stretch;
    padding: 4px 2px 22px;
    scroll-snap-type: x proximity;
  }
  .zw-task-column {
    flex: 0 0 268px;
    min-width: 0;
    background: #f1f4f8;
    border: 1px solid #e1e6ef;
    border-radius: 14px;
    padding: 14px 12px;
    scroll-snap-align: start;
  }
  .zw-task-column > header {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    justify-content: space-between;
    min-height: 60px;
    padding: 2px 4px 14px;
  }
  .zw-task-column > header h2 {
    font-size: 16px;
    line-height: 1.45;
    font-weight: 750;
    color: #34445c;
  }
  .zw-task-column > header > span {
    min-width: 26px;
    padding: 3px 7px;
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    border-radius: 8px;
    background: #e4eaf2;
    color: #475467;
  }
  .zw-task-column[data-stage='in-implementation'] {
    border-top: 3px solid #5378b2;
  }
  .zw-task-column[data-stage='test-staging'] {
    border-top: 3px solid #b38b26;
  }
  .zw-task-column[data-stage='ready-for-production'] {
    border-top: 3px solid #288163;
  }
  .zw-task-column-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .zw-task-compact-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    text-align: left;
    border: 1px solid #dce3ec;
    border-radius: 11px;
    background: #fff;
    color: #26354b;
    padding: 16px;
    cursor: pointer;
    box-shadow: 0 2px 5px #20344c08;
    transition:
      border-color 0.15s,
      box-shadow 0.15s;
  }
  .zw-task-compact-card:hover:not(:disabled) {
    border-color: #9aadc6;
    box-shadow: 0 5px 15px #20344c12;
  }
  .zw-task-compact-card:disabled {
    cursor: default;
    opacity: 0.65;
  }
  .zw-task-compact-card[data-priority='high'] {
    border-left: 3px solid #d95a68;
  }
  .zw-task-compact-card .zw-task-kind-pill {
    align-self: flex-start;
    font-size: 11px;
  }
  .zw-task-compact-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .zw-task-compact-title {
    font-size: 16px;
    line-height: 1.5;
    font-weight: 700;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .zw-task-compact-date {
    display: flex;
    flex-direction: column;
    gap: 3px;
    border-top: 1px solid #edf0f5;
    padding-top: 11px;
    font-size: 12px;
    color: #667085;
  }
  .zw-task-compact-date strong {
    font-size: 15px;
    color: #34445c;
  }
  .zw-task-compact-date[data-overdue='true'] strong {
    color: #a73442;
  }
  .zw-task-compact-owner {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475467;
    overflow-wrap: anywhere;
  }
  .zw-task-owner-avatar {
    flex-shrink: 0;
    display: inline-flex;
    width: 29px;
    height: 29px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #edf2f8;
    color: #506884;
    font-size: 10px;
    font-weight: 700;
  }
  .zw-task-compact-next {
    font-size: 12px;
    line-height: 1.5;
    color: #667085;
  }
  .zw-task-test-link {
    border-radius: 6px;
    padding: 7px 9px;
    background: #fff7e6;
    color: #7f5c1c;
    font-size: 12px;
    font-weight: 650;
  }
  .zw-task-column-empty {
    font-size: 13px;
    color: #78869b;
    padding: 18px 6px;
    line-height: 1.6;
  }
  .zw-task-detail-dialog {
    position: fixed;
    inset: 0;
    margin: auto;
    overflow: auto;
    width: min(1120px, calc(100vw - 40px));
    max-height: calc(100dvh - 40px);
    padding: 0;
    border: 1px solid #dce3ec;
    border-radius: 16px;
    background: #fff;
    color: #26354b;
    box-shadow: 0 20px 80px #10243c35;
  }
  .zw-task-detail-dialog::backdrop {
    background: #172b4666;
    backdrop-filter: blur(2px);
  }
  .zw-task-dialog-heading {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: #fff;
    border-bottom: 1px solid #e5eaf0;
    padding: 14px 22px;
    font-weight: 700;
  }
  .zw-task-detail-dialog .zw-task-card {
    border: 0;
    box-shadow: none;
    border-radius: 0;
  }
  .zw-task-dialog-error,
  .zw-task-dialog-notice {
    padding: 14px 22px !important;
    line-height: 1.6;
    font-size: 14px;
  }
  .zw-task-dialog-error {
    background: #fff1f2;
    color: #a12638;
  }
  .zw-task-dialog-notice {
    background: #eff8f3;
    color: #20644c;
  }
  .zw-task-responsibility {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 24px;
    padding: 12px 0;
    font-size: 14px;
    color: #52647d;
  }
  .zw-task-test-guide {
    margin: 16px 0;
    border: 1px solid #e0e7f1;
    border-radius: 10px;
    background: #f7f9fc;
    padding: 18px 20px;
  }
  .zw-task-test-guide[data-testing='true'] {
    border-color: #e8d5a7;
    background: #fffbf1;
  }
  .zw-task-test-guide h3 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .zw-task-test-guide p {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-size: 15px;
    line-height: 1.75;
    color: #43536b;
  }
  .zw-task-test-editor {
    margin-top: 18px;
    padding: 18px;
    border-radius: 10px;
    background: #f6f8fc;
    border: 1px solid #e1e7f0;
  }
  @media (max-width: 640px) {
    .zw-task-board-controls {
      align-items: flex-start;
      flex-direction: column;
    }
    .zw-task-column {
      flex-basis: min(290px, calc(100vw - 68px));
    }
    .zw-task-detail-dialog {
      width: calc(100vw - 16px);
      max-height: calc(100dvh - 16px);
      border-radius: 10px;
    }
    .zw-task-dialog-heading {
      padding: 12px 16px;
    }
    .zw-task-test-guide {
      padding: 15px;
    }
  }

  .zw-tasks {
    max-width: 1800px;
    padding-top: 18px;
  }
  .zw-task-page-head {
    margin-bottom: 16px;
  }
  .zw-task-summary > div {
    padding: 12px 18px;
  }
  .zw-task-summary strong {
    font-size: 27px;
  }
  .zw-task-filter-panel {
    background: white;
    border: 1px solid #dce3ec;
    border-radius: 11px;
  }
  .zw-task-filter-panel > summary {
    cursor: pointer;
    padding: 10px 16px;
    color: #43536b;
    font-size: 14px;
    font-weight: 650;
  }
  .zw-task-filter-panel > summary > span {
    margin-left: 10px;
    color: #c6001b;
  }
  .zw-task-filter-panel .zw-task-toolbar {
    border: 0;
    border-top: 1px solid #edf0f5;
    border-radius: 0 0 11px 11px;
  }
  .zw-task-board-controls {
    margin: 12px 0;
  }
  /* Keep the cards in view while the optional controls are collapsed. */
  .zw-task-language-bar {
    margin-bottom: 12px;
  }
  .zw-task-intro {
    margin-top: 8px !important;
    line-height: 1.6;
  }
  .zw-task-summary {
    margin-bottom: 16px;
  }
  .zw-task-hours-totals {
    margin-top: 10px;
  }
  .zw-task-summary .zw-task-hours-note {
    margin-top: 8px;
  }
  .zw-task-view-help {
    margin: 8px 0 14px !important;
  }
  .zw-task-billing-panel {
    margin-bottom: 12px;
  }
  .zw-task-billing-panel > summary {
    padding: 12px 18px;
  }
  .zw-task-filter-scope {
    margin-top: 8px !important;
  }
  .zw-task-list-caption {
    padding: 10px 3px;
  }

  /* Keep everyday task editing visible and optional details compact. */
  .zw-task-form-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }
  .zw-task-kind-choice {
    display: block;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
  }
  .zw-task-kind-options {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .zw-task-kind-choice > .zw-task-help {
    margin-top: 8px;
  }
  .zw-task-kind-choice > legend {
    padding: 0 0 10px;
    color: #344c6a;
    font-size: 13px;
    font-weight: 700;
  }
  .zw-task-editor .zw-task-kind-option {
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
    padding: 15px 16px;
    border: 1px solid #dce3ed;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
  }
  .zw-task-kind-option[data-selected='true'] {
    border-color: #6587b0;
    background: #f2f7fd;
    box-shadow: 0 0 0 1px #6587b018;
  }
  .zw-task-editor .zw-task-kind-option input[type='radio'] {
    flex: 0 0 17px;
    width: 17px;
    height: 17px;
    margin: 1px 0 0;
    padding: 0;
    accent-color: #365d87;
  }
  .zw-task-kind-option > span {
    display: grid;
    gap: 5px;
    min-width: 0;
  }
  .zw-task-kind-option strong {
    color: #344c6a;
    font-size: 13px;
    line-height: 1.45;
  }
  .zw-task-kind-option small {
    color: #697b91;
    font-size: 11px;
    font-weight: 400;
    line-height: 1.5;
  }
  .zw-task-editor-core {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(270px, 1fr);
    align-items: start;
    gap: 20px;
    min-width: 0;
  }
  .zw-task-editor-core > *,
  .zw-task-details-body > * {
    min-width: 0;
  }
  .zw-task-editor-core > .zw-task-form-main {
    padding: 19px;
    border: 1px solid #e1e8f2;
    border-radius: 11px;
    background: #fff;
  }
  .zw-task-editor-details {
    min-width: 0;
    border: 1px solid #e1e8f2;
    border-radius: 10px;
    background: #fff;
  }
  .zw-task-editor-details > summary {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 50px;
    padding: 14px 18px;
    color: #344c6a;
    font-size: 13px;
    font-weight: 650;
    line-height: 1.5;
    list-style: none;
    cursor: pointer;
  }
  .zw-task-editor-details > summary::-webkit-details-marker {
    display: none;
  }
  .zw-task-editor-details > summary::before {
    content: '';
    flex: 0 0 7px;
    width: 7px;
    height: 7px;
    margin-right: 3px;
    border-right: 2px solid #7890ab;
    border-bottom: 2px solid #7890ab;
    transform: rotate(-45deg);
  }
  .zw-task-editor-details[open] > summary::before {
    transform: rotate(45deg);
  }
  .zw-task-editor-details[open] > summary {
    border-bottom: 1px solid #edf0f5;
    background: #f9fbfd;
    border-radius: 10px 10px 0 0;
  }
  .zw-task-detail-summary {
    min-width: 0;
    margin-left: auto;
    color: #718199;
    font-size: 11px;
    font-weight: 400;
    text-align: right;
    overflow-wrap: anywhere;
  }
  .zw-task-details-body {
    display: grid;
    gap: 16px;
    min-width: 0;
    padding: 18px;
  }
  .zw-task-details-body > .zw-task-form-group {
    padding: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
  }
  .zw-task-details-body select {
    width: 100%;
    min-width: 0;
    min-height: 41px;
    padding: 10px 12px;
    border: 1px solid #d7dfea;
    border-radius: 8px;
    background: #fff;
    color: #3e4f68;
    font: inherit;
  }
  .zw-task-editor .zw-task-range {
    display: grid;
    gap: 8px;
  }
  .zw-task-editor .zw-task-range > div {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
  .zw-task-editor .zw-task-range > div > label {
    font-size: 12px;
  }
  .zw-task-range-extra {
    min-width: 0;
  }
  .zw-task-range-extra > summary {
    color: #657b96;
    font-size: 11px;
    line-height: 1.6;
    cursor: pointer;
  }
  .zw-task-range-extra[open] > summary {
    margin-bottom: 8px;
  }
  .zw-task-hours-totals {
    grid-template-columns: minmax(0, 1fr);
  }
  .zw-task-hours-metric[data-summary='billable'] {
    border-left: 0;
    padding-left: 0;
  }
  .zw-task-board {
    min-width: 0;
    max-width: 100%;
  }
  .zw-task-column > header h2 {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .zw-task-column > header > span {
    flex-shrink: 0;
  }
  @media (max-width: 900px) {
    .zw-task-editor-core {
      grid-template-columns: minmax(0, 1fr);
    }
  }
  @media (max-width: 640px) {
    .zw-task-kind-options {
      grid-template-columns: minmax(0, 1fr);
    }
    .zw-task-editor-core > .zw-task-form-main,
    .zw-task-details-body {
      padding: 15px;
    }
    .zw-task-editor-details > summary {
      flex-wrap: wrap;
      padding: 13px 15px;
    }
    .zw-task-detail-summary {
      flex-basis: calc(100% - 20px);
      margin-left: 20px;
      text-align: left;
    }
  }

  .zw-task-payment-totals {
    display: flex;
    flex-wrap: wrap;
    gap: 7px 22px;
    font-size: 11px;
    line-height: 1.8;
    margin-top: 9px;
    color: #435a72;
  }
  .zw-task-commercial {
    margin-top: 18px;
    padding: 18px;
    border: 1px solid #d8e5e1;
    border-radius: 12px;
    background: #f7fbfa;
  }
  .zw-task-commercial-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .zw-task-commercial-heading h3 {
    margin: 0 0 6px;
    font-size: 12px;
    color: #516780;
  }
  .zw-task-commercial-heading strong {
    font-size: 13px;
    color: #244e40;
  }
  .zw-task-commercial-heading .zw-task-commercial-total {
    font-size: 22px;
    white-space: nowrap;
  }
  .zw-task-commercial-source {
    margin: 12px 0;
    color: #3e4f68;
    font-size: 12px;
    line-height: 1.6;
    overflow-wrap: anywhere;
  }
  .zw-task-commercial-source small {
    display: block;
    color: #627893;
    font-size: 10px;
  }
  .zw-task-paid-option {
    display: flex;
    gap: 9px;
    align-items: flex-start;
    margin: 13px 0;
    color: #304e43;
    font-size: 12px;
    line-height: 1.7;
  }
  .zw-task-paid-option input {
    margin: 3px 0 0;
    width: 17px;
    height: 17px;
    flex: 0 0 auto;
    accent-color: #25845f;
  }
  .zw-task-commercial-editor {
    display: grid;
    gap: 13px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #d8e5e1;
  }
  .zw-task-commercial-editor label {
    display: grid;
    gap: 7px;
    min-width: 0;
    font-size: 12px;
    font-weight: 600;
    color: #435a72;
  }
  .zw-task-commercial-editor input,
  .zw-task-commercial-editor select {
    width: 100%;
    min-width: 0;
    min-height: 41px;
    box-sizing: border-box;
    border: 1px solid #cddbd6;
    border-radius: 8px;
    padding: 10px 12px;
    background: white;
    font: inherit;
    color: #334b61;
  }
  .zw-task-commercial-editor input:focus-visible,
  .zw-task-commercial-editor select:focus-visible {
    outline: 2px solid #197453;
    outline-offset: 2px;
  }
  .zw-task-agreement-duration {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }
  .zw-task-report-date > summary {
    cursor: pointer;
    font-size: 12px;
    color: #435a72;
  }
  .zw-task-report-date[open] > summary {
    margin-bottom: 12px;
  }
  .zw-task-column[data-stage='production-completed'] {
    border-top-color: #25845f;
    background: #f2f9f5;
  }
  .zw-task-status-pill[data-status='production-completed'] {
    background: #e2f3e8;
    color: #226e4a;
  }
  @media (max-width: 640px) {
    .zw-task-commercial {
      padding: 14px;
    }
    .zw-task-commercial-heading {
      align-items: flex-start;
      flex-wrap: wrap;
    }
    .zw-task-commercial-heading .zw-task-commercial-total {
      font-size: 20px;
    }
  }

  .zw-task-compact-billing {
    display: grid;
    gap: 5px;
    margin: 3px 0 2px;
    padding: 12px 0;
    border-top: 1px solid #e0e6ee;
    border-bottom: 1px solid #e0e6ee;
  }
  .zw-task-compact-billing-label {
    font-size: 12px;
    line-height: 1.5;
    color: #334155;
    font-weight: 600;
  }
  .zw-task-compact-billing-value {
    font-size: 22px;
    line-height: 1.25;
    font-weight: 800;
    color: #111;
    overflow-wrap: anywhere;
  }
  .zw-task-compact-payment {
    font-size: 12px;
    line-height: 1.6;
    color: #334155;
  }
  .zw-task-compact-payment[data-paid='true'] {
    color: #1b6446;
    font-weight: 600;
  }
  .zw-task-billing-feedback {
    margin: 0;
    padding: 11px 13px;
    border: 1px solid #ccd9e7;
    border-radius: 8px;
    font-size: 13px;
    line-height: 1.6;
    background: #f1f6fc;
    color: #263f5b;
    overflow-wrap: anywhere;
  }
  .zw-task-billing-feedback[data-feedback='error'] {
    border-color: #e3b1b1;
    background: #fff3f3;
    color: #8c1e1e;
  }
  .zw-task-billing-feedback[data-feedback='success'] {
    border-color: #b4d8c4;
    background: #edf8f1;
    color: #205a3b;
  }
</style>`;
